import { Body, ExternalLink, LoadingEmptyState } from '@alto/design-system';
import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { markWrongUser } from '~shared/actions/verifications';
import { COMMS_CHANNEL, PHONE } from '~shared/constants';
import { getURLParams } from '~shared/helpers/helper';
import { stripNonDigits } from '~shared/helpers/string';
import { useDispatchShared, useSelectorShared } from '~shared/store';
import { BackLink } from '~web/components/BackLink';
import { PageBackground, SingleColumnContentWrapper } from '~web/components/Page';
import UnauthorizedFormWrapper from '~web/components/UnauthorizedFormWrapper';

type Props = {
  readonly params: {
    readonly verificationType: 'email' | 'phone';
  };
};

function pageText(commsChannel: string, result: boolean | null | undefined) {
  if (result) {
    return <Body>{COMMS_CHANNEL[commsChannel as keyof typeof COMMS_CHANNEL]} successfully removed.</Body>;
  }

  return (
    <Body>
      Please try again or contact support at <ExternalLink href={`tel:${stripNonDigits(PHONE)}`}>{PHONE}</ExternalLink>{' '}
      if the problem persists
    </Body>
  );
}

const NotMePage = ({ params }: Props) => {
  const dispatch = useDispatchShared();
  const { verificationType } = params;
  const { token } = getURLParams();
  const loading = useSelectorShared((state) => state.ui.loading.markingWrongUserLoading);
  const [isMarkedWrongUser, setIsMarkedWrongUser] = useState(false);
  const onIsMarkedWrongUser = useCallback(async () => {
    const response = await dispatch(markWrongUser(token, verificationType));
    setIsMarkedWrongUser(response);
  }, [dispatch, token, verificationType]);

  useEffect(() => {
    onIsMarkedWrongUser();
  }, [onIsMarkedWrongUser]);

  if (loading) {
    return <LoadingEmptyState />;
  }

  return (
    <PageBackground>
      <SingleColumnContentWrapper>
        <UnauthorizedFormWrapper header="">
          <BackLink
            href="https://alto.com"
            text="Return to alto.com"
          />
          {pageText(verificationType, isMarkedWrongUser)}
        </UnauthorizedFormWrapper>
      </SingleColumnContentWrapper>
    </PageBackground>
  );
};

export const NotMe = withRouter(NotMePage);
